import React, { ReactElement } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { ReportHtml } from '../../elements/ReportHtml'
import { ReportsSkeleton } from '../../elements/ReportsSkeleton'
import { ProfitAndLoss as ProfitAndLossNL } from '../NL/profitAndLoss'
import { ProfitAndLossTableActions } from './elements/ProfitAndLossTableActions'
import { useProfitAndLoss } from './hooks/useProfitAndLoss'

export const ProfitAndLoss = (): ReactElement => {
  const { organization } = useUserOrganization()
  const { report, isLoading, isIdle } = useProfitAndLoss()

  if (organization?.countryId === 'NL') {
    return <ProfitAndLossNL />
  }

  return (
    <>
      <ProfitAndLossTableActions />
      {isLoading || isIdle ? <ReportsSkeleton /> : <ReportHtml html={report?.html} />}
    </>
  )
}
